/*
 * @Author: Dom
 * @Date: 2022-05-30 18:07:13
 * @LastEditTime: 2022-05-30 18:55:05
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\activationemail\service.ts
 */
import request from '@/utils/request'
import { SetPasswordApi } from './data.d'
import qs from 'qs'

export async function getPasswordByEmail(params:SetPasswordApi): Promise<any> {
    return request({
        url: '/seller/v1/login/getPasswordByEmail',
        method: 'POST',
        data: qs.stringify(params)
    });
}
